// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1343":"4a41f2f8561b3660","28398":"b6323009d4472833","48846":"6438dbb375600f1b","73527":"0c307e90de1d1b22"}[chunkId] + ".css";
};